import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import DashboardPage from './pages/dashboardPage';
import StockPage from './pages/stockPage';
import AuthenticationPage from './pages/authenticationPage';
import WithdrawalPage from './pages/withdrawalPage';
import TransactionsPage from './pages/transactionsPage';
import ProductCataloguePage from './pages/productCataloguePage';
import AdminDashboardPage from './pages/adminDashboardPage';
import AdminCustomerPage from './pages/adminCustomerPage';
import MaintenancePage from './pages/maintenancePage';

import ProtectedRoute from './routes/ProtectedRoute';
import MaintenanceRoute from './routes/MaintenanceRoute';
import SpoolStockDirectMainPage from './pages/SpoolStockDirectMainPage';

function App() {
  return (
    <Router>
      <div className="App">
        <MaintenanceRoute>
          <Routes>
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/stock"
              element={
                <ProtectedRoute>
                  <StockPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/transcations"
              element={
                <ProtectedRoute>
                  <TransactionsPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/withdraw/:productId"
              element={
                <ProtectedRoute>
                  <WithdrawalPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/company/:customerId"
              element={
                <ProtectedRoute>
                  <AdminCustomerPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/catalogue"
              element={
                <ProtectedRoute>
                  <ProductCataloguePage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />

            <Route
              path="/direct"
              element={
                <ProtectedRoute>
                  <SpoolStockDirectMainPage />
                </ProtectedRoute>
              }
            />

            <Route path="/auth" element={<AuthenticationPage />} />

            <Route
              path="/maintenance"
              element={<MaintenancePage />}
            />
          </Routes>
        </MaintenanceRoute>
      </div>
    </Router>
  );
}

export default App;